import axios from "axios";

export const getGeneralConfiguration = (cancelToken) => {
    return axios.get("/api/services/app/ProgramEventSettings/GetGeneralConfiguration", { cancelToken });
};

export const updateGeneralConfiguration = (config) => {
    return axios.put("/api/services/app/ProgramEventSettings/UpdateGeneralConfiguration", config);
};
